import TipoTramite from './tipoTramite.model';
import TipoTramiteNota from './tipoTramiteNota.model';
import TipoTramiteDocumento from './tipoTramiteDocumento.model';
import TipoTramitePaso from './tipoTramitePaso.model';
import ComponentImportConfig from '../componentImportConfig.model';
import ComponentDesignConfig from '../componentDesignConfig.model';

export {
    TipoTramiteNota,
    TipoTramiteDocumento,
    TipoTramite,
    TipoTramitePaso,
    ComponentDesignConfig,
    ComponentImportConfig
};
export default TipoTramite;